// import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store.js";
import { createBrowserRouter, RouterProvider } from "react-router";
import { routerConfig } from "./config/routerConfig.js";

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter(routerConfig);

root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);
